/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskOtherSecuritiesAmt
 */
export interface ExecRiskOtherSecuritiesAmt {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskOtherSecuritiesAmt
     */
    other_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskOtherSecuritiesAmt
     */
    securities_amt?: number;
}

/**
 * Check if a given object implements the ExecRiskOtherSecuritiesAmt interface.
 */
export function instanceOfExecRiskOtherSecuritiesAmt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskOtherSecuritiesAmtFromJSON(json: any): ExecRiskOtherSecuritiesAmt {
    return ExecRiskOtherSecuritiesAmtFromJSONTyped(json, false);
}

export function ExecRiskOtherSecuritiesAmtFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskOtherSecuritiesAmt {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'other_amt': !exists(json, 'other_amt') ? undefined : json['other_amt'],
        'securities_amt': !exists(json, 'securities_amt') ? undefined : json['securities_amt'],
    };
}

export function ExecRiskOtherSecuritiesAmtToJSON(value?: ExecRiskOtherSecuritiesAmt | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'other_amt': value.other_amt,
        'securities_amt': value.securities_amt,
    };
}

